import App from './App.vue'
import router from './router'
import { VueQueryPlugin, vueQueryPluginOptions } from './plugins/vue-query'
import { VueTolgee } from '@tolgee/vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { tolgee } from './plugins/i18n'
import { usePosthog } from './plugins/posthog'

import './plugins/font-awesome'
import './style/global.scss'

import 'virtual:uno.css'

// iOS ignores viewport user-scalable=no — block pinch / gesture zoom.
const preventZoom = (event: Event) => event.preventDefault()

document.addEventListener('gesturestart', preventZoom, { passive: false })
document.addEventListener('gesturechange', preventZoom, { passive: false })
document.addEventListener('gestureend', preventZoom, { passive: false })
document.addEventListener(
  'touchmove',
  (event) => {
    if (event.touches.length > 1) event.preventDefault()
  },
  { passive: false }
)

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(VueTolgee, { tolgee })
app.use(VueQueryPlugin, vueQueryPluginOptions)

// Same gate as app-next: production builds for prod/stage/dev (not local `yarn serve`).
if (
  import.meta.env.PROD &&
  (import.meta.env.MODE === 'production' || import.meta.env.MODE === 'stage' || import.meta.env.MODE === 'development')
) {
  usePosthog(app, router)
}

app.mount('#caplena-signal')
